import Backbone from 'backbone';
import Radio from 'backbone.radio';
import CollaboratorsLayout from '@/views/collaborators_layout';
var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');
var routerCh = Radio.channel('router');

function show_collaborator_list() {
    var invites = apiCh.request('invite');
    var grants = apiCh.request('grant');

    var account = globalCh.request('active_account');
    var primary = globalCh.request('primary_account');

    let received_invites = new Backbone.Collection();
    let sent_invites = new Backbone.Collection();

    invites.fetch().then(function () {
        received_invites.add(invites.filter(function (model) {
            var invitee = model.get('invitee').toLowerCase();
            return (invitee === primary.get('username').toLowerCase())
                || (invitee === primary.get('email').toLowerCase())
                ;
        }));
    });

    invites.fetch({
        data: {
            'filter[owner.id]': account.id
        }
    })
    .then(function(){
        sent_invites.add(invites.filter(filter_invites_for_account));

        sent_invites.listenTo(invites, 'add', function (model) {
            if (filter_invites_for_account(model))
                sent_invites.add(model);
        });
        sent_invites.listenTo(invites, 'remove', function (model) {
            this.remove(model);
        });
    });

    /**
     * sent_invites collection is a subset of invites from the 
     * global invites collection which contains invites to roles
     * on the given account
     */
    function filter_invites_for_account(model) {
        return model.rel.get('owner').id === account.id;
    }
    
    /**
     * memberships shows all the grants/roles granted on the
     * given account, plus the account itself
     */
    var memberships = new Backbone.Collection();
    memberships.add(account);
    grants.fetch({
        data: {
            'filter[target]': account.id,
        }
    }).done(()=>{
        grants.map(function(grant) {
            if ( grant.rel.get('target') && grant.rel.get('target').get('username') === account.get('username')) {
                memberships.add(grant.rel.get('grantee')); 
            }
        });
    
        var collaborators_layout = new CollaboratorsLayout({
            title: 'Collaborators',
            invites_title: 'Invited to ' + account.get('username'),
            grants_title: 'Working with ' + account.get('username'),
            invites_received_title: 'Invitations received by ' + primary.get('username'),
            roles_accepted_title: 'Roles accepted by ' + primary.get('username'),
            sent_invites: sent_invites,
            invites: invites,
            received_invites: received_invites,
            memberships: memberships,
            model: account
        });
    
        var app_layout = globalCh.request('app_layout');
        app_layout.showChildView('container', collaborators_layout);        
    
        globalCh.request('set_selection', {
            type: 'app',
            id: 'collaborators'
        });
    
        globalCh.request('show_account_secondary_nav', { 
            selected: 'collaborators'
        });
    
        routerCh.request('set_location', 'collaborators', account);
        
    });
}

export default show_collaborator_list;
